import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { LayerApi } from '../api/layer-api';
import { MapLayerUsageApi } from '../api/map-layer-usage-api';
import { GisToolsService } from './gis-tools.service';
import { LayerService } from './layer.service';
import { ToSqlStringService } from './to-sql-string.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/layer-api";
import * as i2 from "./to-sql-string.service";
import * as i3 from "./layer.service";
import * as i4 from "./gis-tools.service";
import * as i5 from "../api/map-layer-usage-api";
var maxBetweenValues = 2;
var twoCharacterFields = ['cty_code', 'district_no', 'county_number', 'district_number', 'county_code', 'county_no', 'cty_number', 'cty_no'];
var FilterService = /** @class */ (function () {
    function FilterService(layerApi, toSqlStringService, layerService, gisToolsService, mapLayerUsageApi) {
        this.layerApi = layerApi;
        this.toSqlStringService = toSqlStringService;
        this.layerService = layerService;
        this.gisToolsService = gisToolsService;
        this.mapLayerUsageApi = mapLayerUsageApi;
        this.applyFilter = new EventEmitter();
    }
    FilterService.prototype.getLayerData = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getLayers([layerId], 'name systemQueryJSON queryJSON tables{name geometryType owner} columns(orderBy:"alias"){alias, name, databaseDataType, separatorCharacter, domainValueBasedFilter} tables { metaTable { id }}')];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FilterService.prototype.populateWorkingQueryFromQuery = function (query, layerColumns) {
        var e_1, _a, _b, _c;
        if (!query) {
            throw new Error('Query cannot be null');
        }
        var deepSubqueries;
        if (query.subqueries) {
            deepSubqueries = query.subqueries.filter(function (sq) { return sq.subqueries && sq.subqueries.length; });
            query.subqueries = query.subqueries.filter(function (sq) { return !(sq.subqueries && sq.subqueries.length); });
        }
        var cloneOfQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(query, false);
        var workingQuery = this.getEmptyQuery();
        if (cloneOfQuery.operator !== 'OR' && cloneOfQuery.operator !== 'AND') {
            if (cloneOfQuery.field) {
                workingQuery.subqueries.push(cloneOfQuery);
            }
            workingQuery.operator = 'AND';
        }
        else {
            workingQuery.operator = cloneOfQuery.operator;
            workingQuery.subqueries = [].concat(cloneOfQuery.subqueries);
            workingQuery.subqueries = workingQuery.subqueries.filter(function (x) { return x; });
        }
        try {
            for (var _d = tslib_1.__values(workingQuery.subqueries), _e = _d.next(); !_e.done; _e = _d.next()) {
                var subquery = _e.value;
                if (subquery.field) {
                    subquery.field = subquery.field.toLowerCase();
                }
                if (!subquery.operatorOptions) {
                    subquery.operatorOptions = this.getOperatorOptionsForSubquery(workingQuery.subqueries[0], layerColumns);
                }
                if (subquery.operator && subquery.operator.toLowerCase() === 'between') {
                    var queryValues = subquery.value.split(',');
                    if (queryValues.length === 2) {
                        subquery.value = this.toSqlStringService.replaceAnyVariables(queryValues[0]) + ", " + this.toSqlStringService.replaceAnyVariables(queryValues[1]);
                    }
                }
                if (this.toSqlStringService.hasAnyVariables(subquery.value)) {
                    subquery.value = this.toSqlStringService.replaceAnyVariables(subquery.value, true);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (workingQuery.subqueries.length === 0) {
            workingQuery.subqueries.push({ field: '', operator: '=', value: null, operatorOptions: this.getOperatorOptionsForSubquery({ field: '', operator: '=', value: null }, null) });
        }
        this.generateChildRecordsQuery(query, workingQuery, layerColumns);
        this.generateJoinTableQuery(query, workingQuery, layerColumns);
        if (deepSubqueries && deepSubqueries.length) {
            (_b = query.subqueries).push.apply(_b, tslib_1.__spread(deepSubqueries));
            (_c = workingQuery.subqueries).push.apply(_c, tslib_1.__spread(deepSubqueries.map(function (dsq) { return (tslib_1.__assign({}, dsq)); })));
        }
        if (workingQuery.subqueries && workingQuery.subqueries.length && !workingQuery.subqueries[0].distinctValues) {
            //debugger;
        }
        return workingQuery;
    };
    FilterService.prototype.generateJoinTableQuery = function (query, workingQuery, layerColumns) {
        var e_2, _a;
        if (query && query.joinRecord) {
            workingQuery.joinRecord = query.joinRecord;
            workingQuery.primaryLayerRMSKeys = query.primaryLayerRMSKeys;
        }
        if (query) {
            var joinTableQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(query.joinTableQuery, false);
            workingQuery.joinTableQuery = { subqueries: [{ field: '', operator: '=', value: null }] };
            if (joinTableQuery.operator !== 'OR' && joinTableQuery.operator !== 'AND') {
                if (joinTableQuery.field && joinTableQuery.field !== '') {
                    workingQuery.joinTableQuery.subqueries = [joinTableQuery];
                }
                workingQuery.joinTableQuery.operator = 'AND';
            }
            else {
                workingQuery.joinTableQuery.operator = joinTableQuery.operator;
                workingQuery.joinTableQuery.subqueries = [].concat(joinTableQuery.subqueries);
            }
            try {
                for (var _b = tslib_1.__values(workingQuery.joinTableQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var subquery = _c.value;
                    subquery.operatorOptions = this.getOperatorOptionsForSubquery(subquery, layerColumns);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    FilterService.prototype.generateChildRecordsQuery = function (query, workingQuery, layerColumns) {
        var e_3, _a;
        if (query && query.childTableRecord) {
            workingQuery.childTableRecord = query.childTableRecord;
        }
        if (query) {
            var childTableQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(query.childTableQuery, false);
            workingQuery.childTableQuery = { subqueries: [{ field: '', operator: '=', value: null }] };
            if (childTableQuery.operator !== 'AND' && childTableQuery.operator !== 'OR') {
                if (childTableQuery.field && childTableQuery.field !== '') {
                    workingQuery.childTableQuery.subqueries = [childTableQuery];
                }
                workingQuery.childTableQuery.operator = 'AND';
            }
            else {
                workingQuery.childTableQuery.operator = childTableQuery.operator;
                workingQuery.childTableQuery.subqueries = [].concat(childTableQuery.subqueries);
            }
            try {
                for (var _b = tslib_1.__values(workingQuery.childTableQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var subquery = _c.value;
                    subquery.operatorOptions = this.getOperatorOptionsForSubquery(subquery, layerColumns);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    /* tslint:disable:cyclomatic-complexity */
    FilterService.prototype.populateDistinctValues = function (layerId, subquery, layerQuery, workingQuery, layerColumns, subqueryIndex, isTable, forcePetl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, e_5, _b, e_6, _c, e_7, _d, petlProjectIdClause, additionalQueryForDistinctValues, _e, _f, sq, _g, _h, lq, layerColumn, queryMap_1, _j, _k, _l, mapIndex, x, orQuery, _m, _o, _p, _q, _r, _s, currentColumn, domainValuesShortDesc_1, _t, _u, _v, _w, _x, val;
            var _this = this;
            return tslib_1.__generator(this, function (_y) {
                switch (_y.label) {
                    case 0:
                        if (!(layerId && subquery && subquery.field)) return [3 /*break*/, 9];
                        subquery.loadingDistinct = true;
                        workingQuery.subqueries = this.populateWorkingSubqueryDisplayProperties(workingQuery.subqueries, layerColumns);
                        subquery.distinctValues = null;
                        subquery.distinctValueColumnName = subquery.field;
                        petlProjectIdClause = this.toSqlStringService.getPetlProjectIdClauseIfPresent(layerId, workingQuery, forcePetl);
                        additionalQueryForDistinctValues = { operator: layerQuery && layerQuery.operator === 'OR' ? 'OR' : 'AND', subqueries: [] };
                        try {
                            for (_e = tslib_1.__values(workingQuery.subqueries.filter(function (query) { return query.subqueries && query.subqueries.length; })), _f = _e.next(); !_f.done; _f = _e.next()) {
                                sq = _f.value;
                                additionalQueryForDistinctValues.subqueries.push(this.toSqlStringService.getSimplifiedDeepCopyOfQuery(sq));
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        if (layerQuery && layerQuery.field && layerQuery.value) {
                            additionalQueryForDistinctValues.subqueries.push(this.toSqlStringService.getSimplifiedDeepCopyOfQuery(layerQuery));
                        }
                        else if (layerQuery && layerQuery.subqueries && layerQuery.subqueries.length && layerQuery.subqueries.length > 0) {
                            try {
                                for (_g = tslib_1.__values(layerQuery.subqueries), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    lq = _h.value;
                                    additionalQueryForDistinctValues.subqueries.push(this.toSqlStringService.getSimplifiedDeepCopyOfQuery(lq));
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                        if (petlProjectIdClause) {
                            this.toSqlStringService.addFilter(additionalQueryForDistinctValues, petlProjectIdClause);
                        }
                        layerColumn = layerColumns.find(function (x) { return x.name.toLowerCase().trim() === subquery.field.toLowerCase().trim(); });
                        if (layerColumn && layerColumn.separatorCharacter) {
                            subquery.separatorCharacter = layerColumn.separatorCharacter;
                        }
                        if (!subquery.filterDistinctOnPrevious) return [3 /*break*/, 5];
                        queryMap_1 = {
                            operator: workingQuery.operator,
                            subqueries: []
                        };
                        try {
                            // iterate through previous subqueries to the one selected
                            for (_j = tslib_1.__values(workingQuery.subqueries.filter(function (q) { return !(q.subqueries && q.subqueries.length); }).entries()), _k = _j.next(); !_k.done; _k = _j.next()) {
                                _l = tslib_1.__read(_k.value, 2), mapIndex = _l[0], x = _l[1];
                                if (mapIndex < subqueryIndex) {
                                    // if previous fields have a value then include them in filter
                                    // if operator is 'NULL' or 'NOT NULL', it will also add to the query
                                    if (x.isMultiple) {
                                        queryMap_1.subqueries.push({ field: x.field, operator: x.operator, isMultiple: x.isMultiple, multiValue: x.multiValue });
                                    }
                                    else if ((x.value && x.value.length > 0) || (x.operator && x.operator.indexOf('NULL') >= 0)) {
                                        queryMap_1.subqueries.push({ field: x.field, operator: x.operator, value: x.value });
                                    }
                                    else {
                                        // if a previous subquery doesn't have value then it prevents filtering
                                        // turn flag back off and break loop
                                        subquery.filterDistinctOnPrevious = false;
                                        break;
                                    }
                                }
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        if (!subquery.filterDistinctOnPrevious) return [3 /*break*/, 4];
                        if (!(additionalQueryForDistinctValues.operator === 'OR' && additionalQueryForDistinctValues.subqueries.length)) return [3 /*break*/, 2];
                        orQuery = {
                            operator: additionalQueryForDistinctValues.operator,
                            subqueries: additionalQueryForDistinctValues.subqueries
                        };
                        queryMap_1.subqueries.push(orQuery);
                        _m = subquery;
                        _o = this.mapDistinctValues;
                        _p = [subquery, layerColumns];
                        return [4 /*yield*/, this.getDistictValues(layerId, subquery.field, isTable, queryMap_1)];
                    case 1:
                        _m.distinctValues = _o.apply(this, _p.concat([_y.sent()]));
                        return [3 /*break*/, 4];
                    case 2:
                        additionalQueryForDistinctValues.subqueries.forEach(function (aqfdv) { return queryMap_1 = _this.toSqlStringService.addQueryClauseIfNotPresent(queryMap_1, aqfdv); });
                        _q = subquery;
                        _r = this.mapDistinctValues;
                        _s = [subquery, layerColumns];
                        return [4 /*yield*/, this.getDistictValues(layerId, subquery.field, isTable, queryMap_1)];
                    case 3:
                        _q.distinctValues = _r.apply(this, _s.concat([_y.sent()]));
                        _y.label = 4;
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        if (!(subquery.previousFilterDistinctOnPreviousValue !== subquery.filterDistinctOnPrevious || !subquery.distinctValues)) return [3 /*break*/, 8];
                        currentColumn = layerColumns.find(function (column) { return column.name === subquery.field; });
                        if (!currentColumn) return [3 /*break*/, 8];
                        if (!(currentColumn.domainValueBasedFilter === 'T')) return [3 /*break*/, 6];
                        domainValuesShortDesc_1 = [];
                        //gets column data and fills array
                        currentColumn.domainValues.forEach(function (value) {
                            domainValuesShortDesc_1.push({ text: value.shortDescription, value: value.shortDescription });
                        });
                        //sorts alphabetically by text displayed to user
                        domainValuesShortDesc_1.sort(function (a, b) { return a.text.localeCompare(b.text); });
                        //sets values to variable that is returned
                        subquery.distinctValues = domainValuesShortDesc_1;
                        return [3 /*break*/, 8];
                    case 6:
                        _t = subquery;
                        _u = this.mapDistinctValues;
                        _v = [subquery, [currentColumn]];
                        return [4 /*yield*/, this.getDistictValues(layerId, subquery.field, isTable, additionalQueryForDistinctValues)];
                    case 7:
                        _t.distinctValues = _u.apply(this, _v.concat([_y.sent()]));
                        _y.label = 8;
                    case 8:
                        if (subquery.distinctValues && subquery.distinctValues.length && subquery.distinctValues.length > 0) {
                            subquery.filteredDistinctValues = this.sortSubQuery(subquery.distinctValues);
                        }
                        subquery.filteredDistinctValues = this.sortIfDate(subquery.filteredDistinctValues, layerColumns, subquery.field);
                        subquery.customValues = [];
                        if (subquery.value != null) {
                            if (this.showMultiple(subquery.operator)) {
                                if (!subquery.isMultiple && !subquery.multiValue) {
                                    subquery.isMultiple = true;
                                    subquery.multiValue = subquery.value.split(',').filter(function (v) { return v.trim() !== ''; });
                                }
                                try {
                                    for (_w = tslib_1.__values(subquery.multiValue), _x = _w.next(); !_x.done; _x = _w.next()) {
                                        val = _x.value;
                                        if (subquery.filteredDistinctValues && !subquery.filteredDistinctValues.map(function (x) { return x.value.toLowerCase(); }).includes(val.toLowerCase())) {
                                            subquery.filteredDistinctValues.push({ value: val, text: val });
                                            if (!subquery.customValues.map(function (cv) { return cv.toLowerCase(); }).includes(val.toLowerCase())) {
                                                subquery.customValues.push(val);
                                            }
                                        }
                                    }
                                }
                                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                                finally {
                                    try {
                                        if (_x && !_x.done && (_d = _w.return)) _d.call(_w);
                                    }
                                    finally { if (e_7) throw e_7.error; }
                                }
                            }
                            else if (subquery.value.indexOf(',') === -1 && subquery.filteredDistinctValues && !subquery.filteredDistinctValues.map(function (fdv) { return fdv.value && fdv.value.toLowerCase(); }).includes(subquery.value.toLowerCase())) {
                                subquery.filteredDistinctValues.push({ value: subquery.value, text: subquery.value });
                                if (!subquery.customValues.map(function (cv) { return cv.toLowerCase(); }).includes(subquery.value.toLowerCase())) {
                                    subquery.customValues.push(subquery.value);
                                }
                            }
                        }
                        subquery.loadingDistinct = false;
                        _y.label = 9;
                    case 9: return [2 /*return*/, subquery];
                }
            });
        });
    };
    FilterService.prototype.populateWorkingSubqueryDisplayProperties = function (workingSubqueries, layerColumns) {
        var e_8, _a;
        var subQueries = [];
        if (workingSubqueries && workingSubqueries.length) {
            try {
                for (var workingSubqueries_1 = tslib_1.__values(workingSubqueries), workingSubqueries_1_1 = workingSubqueries_1.next(); !workingSubqueries_1_1.done; workingSubqueries_1_1 = workingSubqueries_1.next()) {
                    var subquery = workingSubqueries_1_1.value;
                    var workingSubquery = subquery;
                    if (!workingSubquery.field || workingSubquery.distinctValueColumnName !== workingSubquery.field) {
                        workingSubquery.distinctValueColumnName = undefined;
                        workingSubquery.distinctValues = undefined;
                    }
                    workingSubquery.isMultiple = this.showMultiple(subquery.operator);
                    workingSubquery.disableDistinctValues = !subquery.field;
                    workingSubquery.disableValueEntry = !subquery.operator || subquery.operator.indexOf('NULL') >= 0;
                    workingSubquery.inputType = this.getInputTypeForSubQuery(subquery, layerColumns);
                    workingSubquery.operatorOptions = this.getOperatorOptionsForSubquery(subquery, layerColumns);
                    if (workingSubquery.isMultiple) {
                        if (workingSubquery.multiValue) {
                            workingSubquery.value = workingSubquery.multiValue.toString();
                        }
                        else if (workingSubquery.value !== null) {
                            workingSubquery.multiValue = workingSubquery.value.split(',').map(function (v) { return v.trim(); });
                        }
                    }
                    else {
                        if (!workingSubquery.value || workingSubquery.value === '') {
                            workingSubquery.multiValue = [];
                        }
                        else {
                            workingSubquery.multiValue = workingSubquery.value.split(',').map(function (v) { return v.trim(); });
                        }
                    }
                    if (subquery.separatorCharacter) {
                        workingSubquery.separatorCharacter = subquery.separatorCharacter;
                    }
                    subQueries.push(workingSubquery);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (workingSubqueries_1_1 && !workingSubqueries_1_1.done && (_a = workingSubqueries_1.return)) _a.call(workingSubqueries_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
            subQueries = workingSubqueries;
        }
        else {
            workingSubqueries = [{ field: '', operator: '=', value: null }];
            workingSubqueries[0].operatorOptions = this.getOperatorOptionsForSubquery(workingSubqueries[0], layerColumns);
        }
        return workingSubqueries;
    };
    FilterService.prototype.getDistictValues = function (Id, columnName, isTable, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var distinctValues, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        distinctValues = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!isTable) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.layerApi.getDistinctTableValues(Id, columnName)];
                    case 2:
                        distinctValues = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.layerApi.getDistinctValues(Id, columnName, this.toSqlStringService.getSimplifiedDeepCopyOfQuery(query))];
                    case 4:
                        distinctValues = _b.sent();
                        _b.label = 5;
                    case 5:
                        if (distinctValues) {
                            return [2 /*return*/, distinctValues];
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, []];
                }
            });
        });
    };
    FilterService.prototype.clearValuesIfNeeded = function (subqueries) {
        var e_9, _a;
        if (subqueries) {
            try {
                for (var subqueries_1 = tslib_1.__values(subqueries), subqueries_1_1 = subqueries_1.next(); !subqueries_1_1.done; subqueries_1_1 = subqueries_1.next()) {
                    var subquery = subqueries_1_1.value;
                    if (subquery.operator && subquery.operator.includes('NULL')) {
                        subquery.value = null;
                    }
                    if (subquery.operator && subquery.operator.includes('BETWEEN') && subquery.multiValue) {
                        subquery.multiValue = subquery.multiValue.slice(-(maxBetweenValues));
                    }
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (subqueries_1_1 && !subqueries_1_1.done && (_a = subqueries_1.return)) _a.call(subqueries_1);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
    };
    FilterService.prototype.offSetIsNumber = function (offsetEndColName, layerColumns) {
        var e_10, _a;
        if (offsetEndColName !== null) {
            try {
                for (var layerColumns_1 = tslib_1.__values(layerColumns), layerColumns_1_1 = layerColumns_1.next(); !layerColumns_1_1.done; layerColumns_1_1 = layerColumns_1.next()) {
                    var column = layerColumns_1_1.value;
                    if (column.name.toLowerCase() === offsetEndColName.toLowerCase()) {
                        return ((column.dataType && ['number', 'float', 'long'].indexOf(column.dataType.toLowerCase()) > -1) ? true : false || (column.databaseDataType && ['number', 'float', 'long'].indexOf(column.databaseDataType.toLowerCase()) > -1) ? true : false);
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (layerColumns_1_1 && !layerColumns_1_1.done && (_a = layerColumns_1.return)) _a.call(layerColumns_1);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        return false;
    };
    FilterService.prototype.getFinalizedQuery = function (workingQuery) {
        for (var i = 0, l = workingQuery.subqueries.filter(function (sq) { return sq.field && sq.value; }).length; i < l - 1; i++) {
            if ((workingQuery.subqueries[i].value.length === 1) && (twoCharacterFields.indexOf(workingQuery.subqueries[i].field) >= 0)) {
                workingQuery.subqueries[i].value = '0' + workingQuery.subqueries[i].value;
            }
        }
        for (var i = 0, l = workingQuery.childTableQuery.subqueries.length; i < l - 1; i++) {
            if ((workingQuery.childTableQuery.subqueries[i].value.length === 1) && (twoCharacterFields.indexOf(workingQuery.childTableQuery.subqueries[i].field) >= 0)) {
                workingQuery.childTableQuery.subqueries[i].value = '0' + workingQuery.childTableQuery.subqueries[i].value;
            }
        }
        for (var i = 0, l = workingQuery.joinTableQuery.subqueries.length; i < l - 1; i++) {
            if ((workingQuery.joinTableQuery.subqueries[i].value.length === 1) && (twoCharacterFields.indexOf(workingQuery.joinTableQuery.subqueries[i].field) >= 0)) {
                workingQuery.joinTableQuery.subqueries[i].value = '0' + workingQuery.joinTableQuery.subqueries[i].value;
            }
        }
        var query = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(workingQuery, false);
        query.value = this.toSqlStringService.replaceAnyVariables(query.value);
        query.childTableQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(workingQuery.childTableQuery, false);
        query.childTableRecord = workingQuery.childTableRecord;
        query.joinTableQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(workingQuery.joinTableQuery, false);
        query.joinRecord = workingQuery.joinRecord;
        query.primaryLayerRMSKeys = workingQuery.primaryLayerRMSKeys;
        return query;
    };
    FilterService.prototype.getInputTypeForSubQuery = function (query, layerColumns) {
        var databaseType = this.getDatabaseTypeForSubQuery(query, layerColumns);
        if (databaseType) {
            databaseType = databaseType.toLowerCase();
        }
        if (query.operator &&
            (query.operator.indexOf('IN') >= 0
                || (query.operator.indexOf('BETWEEN') >= 0 && databaseType !== 'date')
                || query.operator.indexOf('INCLUDES') >= 0
                || query.operator === 'GUID')) {
            return 'text';
        }
        if (query.operator && query.operator.indexOf('NULL') >= 0) {
            return 'null';
        }
        switch (databaseType) {
            case 'number':
            case 'float':
                return 'number';
            case 'date':
                return 'date';
            default:
                return 'text';
        }
    };
    FilterService.prototype.getDatabaseTypeForSubQuery = function (subquery, layerColumns) {
        var databaseType = null;
        if (subquery.field && layerColumns && layerColumns.length > 0) {
            var layerColumn = layerColumns.find(function (x) { return x.name.toLowerCase().trim() === subquery.field.toLowerCase().trim(); });
            if (layerColumn) {
                databaseType = isLayerColumn(layerColumn) ? layerColumn.databaseDataType : layerColumn.dataType;
            }
        }
        return databaseType;
    };
    FilterService.prototype.getOperatorOptionsForSubquery = function (subquery, layerColumns) {
        var databaseType = this.getDatabaseTypeForSubQuery(subquery, layerColumns);
        return this.toSqlStringService.getOperatorOptionsForDatatype(databaseType);
    };
    FilterService.prototype.showMultiple = function (operator) {
        return operator === 'IN' || operator === 'NOT IN' || operator === 'INCLUDES' || operator === 'NOT INCLUDES' || operator === 'BETWEEN' || operator === 'NOT BETWEEN';
    };
    FilterService.prototype.getEmptyQuery = function () {
        return { operator: 'AND', subqueries: [], joinTableQuery: { subqueries: [], operator: 'AND' }, childTableQuery: { subqueries: [], operator: 'AND' } };
    };
    FilterService.prototype.populateWorkingSql = function (layerQuery, workingQuery, baseTable, layerColumns) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rootQuery;
            return tslib_1.__generator(this, function (_a) {
                rootQuery = { operator: 'AND', subqueries: [] };
                rootQuery.subqueries.push(layerQuery);
                rootQuery.subqueries.push(workingQuery);
                return [2 /*return*/, this.toSqlStringService.getSQLFromQuery(rootQuery, baseTable, layerColumns)];
            });
        });
    };
    FilterService.prototype.populateSummaryFromQuery = function (workingQuery, layerColumns, joinColumns, childColumns) {
        var summaryItemsString = '';
        var basicSummaryString = '';
        var joinSummaryString = '';
        var childRecordsSummaryString = '';
        var stringList = [];
        workingQuery.value = this.toSqlStringService.replaceAnyVariables(workingQuery.value);
        basicSummaryString = this.toSqlStringService.getSummaryStringForQuery(workingQuery, layerColumns);
        if (basicSummaryString !== '') {
            stringList.push(basicSummaryString);
        }
        joinSummaryString = this.toSqlStringService.getJoinFilterSummaryFromQuery(workingQuery, joinColumns);
        if (joinSummaryString !== '') {
            stringList.push(joinSummaryString);
        }
        childRecordsSummaryString = this.toSqlStringService.getChildFilterSummaryFromQuery(workingQuery, childColumns);
        if (childRecordsSummaryString !== '') {
            stringList.push(childRecordsSummaryString);
        }
        summaryItemsString = stringList.join(' and ');
        if (summaryItemsString !== '' && summaryItemsString.indexOf('when') === -1) {
            summaryItemsString = "when " + summaryItemsString;
        }
        return summaryItemsString;
    };
    FilterService.prototype.getSummaryQuery = function (workingQuery, layerColumns, joinColumns, childColumns) {
        var summaryItemsString = '';
        var basicSummaryString = '';
        var joinSummaryString = '';
        var childRecordsSummaryString = '';
        var stringList = [];
        basicSummaryString = this.toSqlStringService.parseIQueryToString(workingQuery, layerColumns);
        if (basicSummaryString !== '') {
            stringList.push(basicSummaryString);
        }
        joinSummaryString = this.toSqlStringService.getJoinFilterSummaryFromQuery(workingQuery, joinColumns);
        if (joinSummaryString !== '') {
            stringList.push(joinSummaryString);
        }
        childRecordsSummaryString = this.toSqlStringService.getChildFilterSummaryFromQuery(workingQuery, childColumns);
        if (childRecordsSummaryString !== '') {
            stringList.push(childRecordsSummaryString);
        }
        summaryItemsString = stringList.join(' and ');
        return summaryItemsString;
    };
    FilterService.prototype.sortIfDate = function (vals, layerColumns, field) {
        var result = layerColumns.filter(function (x) { return x.name.toUpperCase() === field.toUpperCase(); });
        if (result.length > 0 && ((result[0].databaseDataType && result[0].databaseDataType.toUpperCase() === 'DATE') || (result[0].dataType && result[0].dataType.toUpperCase() === 'DATE'))) {
            var dateList_1 = [];
            vals.sort(function (a, b) {
                return Number(new Date(a.text)) - Number(new Date(b.text));
            });
            vals.forEach(function (val) {
                var date = new Date(val.text);
                var newDate = val.text.toUpperCase() === 'NULL' ? val.text : date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
                var value = val.value.toUpperCase() === 'NULL' ? val.value : date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
                if (!dateList_1.filter(function (x) { return x.value === value; }).length) {
                    dateList_1.push({ text: newDate, value: value });
                }
            });
            vals = dateList_1;
        }
        return vals;
    };
    FilterService.prototype.sortSubQuery = function (s) {
        var returnType = typeof (s[0]);
        if (returnType === 'string') {
            var reg = /^\d+$/;
            returnType = reg.test(s[0]) ? 'number' : 'string';
        }
        var isSorted = true;
        //see if values need sorted
        if (returnType === 'number') {
            for (var i = 0; i < s.length - 1; i++) {
                var a = parseInt(s[i], 10);
                var b = parseInt(s[i + 1], 10);
                if (a > b) {
                    isSorted = false;
                    break;
                }
            }
        }
        else if (returnType === 'string') {
            for (var i = 0; i < s.length - 1; i++) {
                var a = s[i];
                var b = s[i + 1];
                if (a.localeCompare(b) > 0) {
                    isSorted = false;
                    break;
                }
            }
        }
        //sort if needed
        if (!isSorted && returnType === 'number') {
            return s.sort(function (a, b) {
                var numA = parseInt(a, 10);
                var numB = parseInt(b, 10);
                if (numA < numB) {
                    return -1;
                }
                if (numA > numB) {
                    return 1;
                }
                return 0;
            });
        }
        else if (!isSorted && returnType === 'string') {
            return s.sort(function (a, b) {
                var comparison = a.localeCompare(b);
                if (comparison < 0) {
                    return -1;
                }
                else if (comparison > 0) {
                    return 1;
                }
                return 0;
            });
        }
        else {
            return s;
        }
    };
    FilterService.prototype.saveLayerUsage = function (layerId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filters, districts;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filters = this.extractQueryInfo(query);
                        return [4 /*yield*/, this.getDistrictsFromFilters(filters)];
                    case 1:
                        districts = _a.sent();
                        if (districts && districts.length && districts.length > 0) {
                            districts.forEach(function (district) {
                                _this.mapLayerUsageApi.saveLayerUsage(layerId, JSON.stringify(filters), district);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterService.prototype.extractQueryInfo = function (query, results) {
        if (results === void 0) { results = []; }
        var e_11, _a;
        if (query.field && query.operator) {
            var info = {
                field: query.field,
                operator: query.operator
            };
            if (query.primaryLayerRMSKeys) {
                info.primaryLayerRMSKeys = query.primaryLayerRMSKeys;
            }
            if (query.isMultiple && query.multiValue) {
                info.multiValue = query.multiValue;
            }
            else if (query.value) {
                info.value = query.value;
            }
            results.push(info);
        }
        if (query.subqueries && query.subqueries.length > 0) {
            try {
                for (var _b = tslib_1.__values(query.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var subquery = _c.value;
                    this.extractQueryInfo(subquery, results);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        return results;
    };
    FilterService.prototype.getDistrictsFromFilters = function (filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_12, _a, districts, filters_1, filters_1_1, filter, district, isCountyRelated, counties, e_12_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        districts = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, 10, 11]);
                        filters_1 = tslib_1.__values(filters), filters_1_1 = filters_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!filters_1_1.done) return [3 /*break*/, 8];
                        filter = filters_1_1.value;
                        if (filter.field.toLowerCase().indexOf('district') > -1) {
                            district = parseInt(filter.value, 0);
                            if (!districts.includes(district)) {
                                districts.push(district);
                            }
                        }
                        isCountyRelated = filter.primaryLayerRMSKeys && filter.primaryLayerRMSKeys.ctyCodeColName === filter.field ||
                            filter.field.toLowerCase().indexOf('cty_code') > -1 ||
                            filter.field.toLowerCase().indexOf('county') > -1;
                        if (!isCountyRelated) return [3 /*break*/, 7];
                        counties = void 0;
                        if (!(filter.multiValue && filter.multiValue.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.gisToolsService.getCounties(filter.multiValue.map(function (c) { return parseInt(c, 0); }))];
                    case 3:
                        counties = _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!filter.value) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.gisToolsService.getCounties([parseInt(filter.value, 0)])];
                    case 5:
                        counties = _b.sent();
                        _b.label = 6;
                    case 6:
                        if (counties && counties.length > 0) {
                            counties.forEach(function (county) {
                                var district = parseInt(county.districtNumber, 0);
                                if (!districts.includes(district)) {
                                    districts.push(district);
                                }
                            });
                        }
                        _b.label = 7;
                    case 7:
                        filters_1_1 = filters_1.next();
                        return [3 /*break*/, 2];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_12_1 = _b.sent();
                        e_12 = { error: e_12_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (filters_1_1 && !filters_1_1.done && (_a = filters_1.return)) _a.call(filters_1);
                        }
                        finally { if (e_12) throw e_12.error; }
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/, districts];
                }
            });
        });
    };
    FilterService.prototype.populateExternalDistinctValues = function (externalLayerId, subquery, workingQuery, workingSql, subqueryIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_13, _a, esriLayer, prop, query, joinOperator, endIndex, stats, retData, distValues, _b, _c, feature, val;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        esriLayer = this.layerService.getEsriLayerByUniqueId(externalLayerId);
                        if (!subquery.field) {
                            return [2 /*return*/, subquery];
                        }
                        subquery.loadingDistinct = true;
                        subquery.distinctValueColumnName = subquery.field;
                        prop = subquery.field.toUpperCase();
                        query = esriLayer.createQuery();
                        if (subquery.filterDistinctOnPrevious) {
                            if (subqueryIndex === 0) {
                                //first subquery can't filter by previous
                                query.where = '1=1';
                            }
                            else {
                                joinOperator = workingQuery.operator;
                                endIndex = this.nthOccurrence(workingSql, joinOperator, subqueryIndex);
                                if (endIndex === -1) {
                                    //didn't find an extra instance of joinOperator, so use full sql
                                    endIndex = workingSql.length;
                                }
                                query.where = workingSql.substring(0, endIndex);
                            }
                        }
                        else {
                            query.where = '1=1';
                        }
                        query.spatialRelationship = 'intersects';
                        query.outFields = [prop];
                        stats = {
                            statisticType: 'count',
                            onStatisticField: prop
                        };
                        query.outStatistics = [stats];
                        query.groupByFieldsForStatistics = [prop];
                        return [4 /*yield*/, esriLayer.queryFeatures(query)];
                    case 1:
                        retData = _d.sent();
                        distValues = [];
                        if (retData) {
                            try {
                                for (_b = tslib_1.__values(retData.features), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    feature = _c.value;
                                    val = feature.attributes[prop];
                                    if (!val && feature.attributes.Expr1) {
                                        val = feature.attributes.Expr1.toString();
                                    }
                                    distValues.push(val);
                                }
                            }
                            catch (e_13_1) { e_13 = { error: e_13_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_13) throw e_13.error; }
                            }
                            subquery.distinctValues = tslib_1.__spread(distValues).map(function (dv) { return ({ text: dv, value: dv }); });
                            subquery.filteredDistinctValues = this.sortSubQuery(subquery.distinctValues);
                        }
                        subquery.loadingDistinct = false;
                        return [2 /*return*/, subquery];
                }
            });
        });
    };
    FilterService.prototype.nthOccurrence = function (s1, s2, n) {
        var temp = s1;
        var tempIndex = -1;
        var finalIndex = 0;
        for (var occurence = 0; occurence < n; occurence += 1) {
            tempIndex = temp.indexOf(s2);
            if (tempIndex === -1) {
                finalIndex = 0;
                break;
            }
            temp = temp.substring(tempIndex += 1);
            finalIndex += tempIndex;
        }
        return finalIndex -= 1;
    };
    FilterService.prototype.mapDistinctValues = function (subquery, columns, distinctValues) {
        var e_14, _a;
        var retVal = [];
        if (distinctValues) {
            retVal = distinctValues.map(function (dv) { return ({ text: dv, value: dv }); });
            if (subquery && subquery.field && columns) {
                var matchingColumn = columns.find(function (c) { return c.name.toLowerCase().trim() === subquery.field.toLowerCase().trim(); });
                if (matchingColumn && matchingColumn.domainValues) {
                    var _loop_1 = function (v) {
                        var matchingValue = matchingColumn.domainValues.find(function (dv) { return (subquery.inputType && subquery.inputType === 'number' ? parseFloat(dv.codeValue.toString()) : dv.codeValue).toString() === v.value; });
                        if (matchingValue) {
                            v.text = matchingValue.codeValue + " - " + matchingValue.shortDescription;
                        }
                    };
                    try {
                        for (var retVal_1 = tslib_1.__values(retVal), retVal_1_1 = retVal_1.next(); !retVal_1_1.done; retVal_1_1 = retVal_1.next()) {
                            var v = retVal_1_1.value;
                            _loop_1(v);
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (retVal_1_1 && !retVal_1_1.done && (_a = retVal_1.return)) _a.call(retVal_1);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                }
            }
        }
        return retVal;
    };
    FilterService.prototype.onApplyFilter = function (esriLayer) {
        this.applyFilter.emit(esriLayer);
    };
    FilterService.ngInjectableDef = i0.defineInjectable({ factory: function FilterService_Factory() { return new FilterService(i0.inject(i1.LayerApi), i0.inject(i2.ToSqlStringService), i0.inject(i3.LayerService), i0.inject(i4.GisToolsService), i0.inject(i5.MapLayerUsageApi)); }, token: FilterService, providedIn: "root" });
    return FilterService;
}());
export { FilterService };
function isLayerColumn(layerColumn) {
    return Object.keys(layerColumn).includes('databaseDataType');
}
